import { HowTo } from '@models/guides/howToGuide.model';
import { EnvToken } from '@app/core/env.tokens';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { urlDecode } from '@utils/urlHelpers';
@Injectable({
  providedIn: 'root',
})
export class GuideService {
  protected readonly env = inject(EnvToken);

  baseHref = this.env.dashboardBaseRef;
  apiPrefix = this.env.apiPrefix;

  constructor(private http: HttpClient) {}

  fetchGuideBySlug(
    slug: string,
    mainCat?: string,
    subCat?: string,
  ): Observable<HowTo> {
    const slugDecoded = urlDecode(slug.toLowerCase().trim());
    const url =
      `${this.baseHref}` + `api/${this.apiPrefix}guide/${slugDecoded}/active`;
    let params = new HttpParams();
    if (mainCat) {
      const catSlugDecoded = urlDecode(mainCat.toLowerCase().trim());
      params = params.set('mainCat', catSlugDecoded);
    }
    if (subCat) {
      const subCatDecoded = urlDecode(subCat.toLowerCase().trim());
      params = params.set('subCat', subCatDecoded);
    }
    return this.http.get<HowTo>(url, { params });
  }

  fetchGuideByCategory(asCat: number, currentId: string): Observable<HowTo[]> {
    const url =
      `${this.baseHref}` +
      `api/${this.apiPrefix}guide/category/${asCat}/${currentId}/active`;
    return this.http.get<HowTo[]>(url);
  }

  fetchGuideCategories(): Observable<any[]> {
    const url =
      `${this.baseHref}` + `api/${this.apiPrefix}guide/categories/active`;
    return this.http.get<any[]>(url);
  }

  fetchGuidesOverview(): Observable<any[]> {
    const url = `${this.baseHref}` + `api/${this.apiPrefix}guide/overview`;
    return this.http.get<any[]>(url);
  }
}
